interface InitialPlayButtonProps {
  onClick: () => void;
}

export function InitialPlayButton({ onClick }: InitialPlayButtonProps) {
  return (
    // `counting-initial-play` is a stable hook for index.css: on the rebuilt Counting table this
    // button sits on green baize, where a felt-green circle is invisible, so it is re-coloured
    // brass there. No rule targets the class by default — the legacy pages are unaffected.
    <button
      onClick={onClick}
      className="counting-initial-play absolute inset-0 m-auto w-16 h-16 flex items-center justify-center
        bg-felt hover:bg-felt-deep rounded-full text-white cursor-pointer
        transition-all duration-200 hover:scale-110 z-10"
      aria-label="Play"
      title="Play"
      data-testid="initial-play-button"
    >
      <svg viewBox="0 0 20 20" fill="currentColor" width="40%" height="40%">
        <polygon points="6,2 18,10 6,18" />
      </svg>
    </button>
  );
}
